import { useTranslation } from 'react-i18next';
import Animated, { withDelay, withSpring } from 'react-native-reanimated';

import { SgpIcon } from '@/components/SgpIcon';
import { Text } from '@/components/TextComponent';
import { ds } from '@/components/lib/design.system';
import {
    getEnteringAnimation,
    getExitingAnimation,
    getLayoutAnimationsTransition,
} from '@/utils/animations/layout-animations-utils';

import { BetType, isParlayBetType, isSgpBetType } from './PickSlipBarContent';
import { styles } from './PickSlipBarRightContent';

const PickText = ({ text }: { text: string }) => (
    <Text variant="titleMedium" fontSize={14} color={ds.colorToken.text.primary}>
        {text}
    </Text>
);

type PickSlipBarLeftContentProps = {
    betType: BetType;
    selectionCount: number;
    hasRendered: boolean;
};

export const PickSlipBarLeftContent = ({ betType, selectionCount, hasRendered }: PickSlipBarLeftContentProps) => {
    const { t } = useTranslation('betslip_sbk');

    const layoutTransition = getLayoutAnimationsTransition();

    return (
        <Animated.View layout={layoutTransition} style={styles.container}>
            <AnimatedSgpIcon betType={betType} hasRendered={hasRendered} />
            {betType === 'SINGLE' ? (
                <PickText text={t('single_pick')} />
            ) : isParlayBetType(betType) ? (
                <PickText text={t('parlay_pick', { count: selectionCount })} />
            ) : betType === 'GENERIC' ? (
                <PickText text={t('picks_count', { count: selectionCount })} />
            ) : null}
        </Animated.View>
    );
};

type AnimatedSgpIconProps = {
    betType: BetType;
    hasRendered: boolean;
};

const AnimatedSgpIcon = ({ betType, hasRendered }: AnimatedSgpIconProps) => {
    if (!isSgpBetType(betType)) {
        return null;
    }

    return (
        <Animated.View
            entering={getEnteringAnimation(slideInFromRightEntering, hasRendered)}
            exiting={getExitingAnimation(slideOutToRightExiting)}
        >
            <SgpIcon isSgpPlus={betType === 'SGP+'} />
        </Animated.View>
    );
};

const slideInFromRightEntering = () => {
    'worklet';
    const animations = {
        opacity: withDelay(
            50,
            withSpring(1, {
                damping: 20,
                stiffness: 300,
                mass: 0.5,
            })
        ),
        transform: [
            {
                translateX: withSpring(0, {
                    damping: 10,
                    stiffness: 140,
                    mass: 0.35,
                }),
            },
        ],
    };
    const initialValues = {
        opacity: 0,
        transform: [{ translateX: -10 }],
    };
    return {
        initialValues,
        animations,
    };
};

const slideOutToRightExiting = () => {
    'worklet';
    const animations = {
        opacity: 0,
        transform: [
            {
                translateX: withSpring(-10, {
                    damping: 10,
                    stiffness: 120,
                    mass: 0.35,
                }),
            },
        ],
    };
    const initialValues = {
        opacity: 1,
        transform: [{ translateX: 0 }],
    };
    return {
        initialValues,
        animations,
    };
};
